module.exports = __webpack_public_path__ + "img/facebook-icon.8a2bbd82.svg";